import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import axios from "axios";

const token = localStorage.getItem('authToken');

class AddDeals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      description: '',
      discount_amount: '',
      original_price: '',
      deal_price: '',
      start_date: '',
      end_date: '',
      coupon_code: '',
      image: null,
      storeId: '',
      productCategoryId: '',
      brandId: '',
      stores: [],  // List of stores with IDs
      productCategories: [],  // List of categories with IDs
      brands: [],  // List of brands with IDs
      submissionStatus: null,
    };
  }

  // Fetch stores, product categories, and brands when the component mounts
  async componentDidMount() {
    try {
      const [storesResponse, categoriesResponse, brandsResponse] = await Promise.all([
        axios.get("https://brand.aasmo.in/api/admin/brands", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get("https://brand.aasmo.in/api/admin/getall-category", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get("https://brand.aasmo.in/api/admin/brandsnew", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      this.setState({
        stores: storesResponse?.data?.brands,
        productCategories: categoriesResponse?.data?.categories,
        brands: brandsResponse?.data?.data,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (e) => {
    this.setState({ image: e.target.files[0] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { title, description, discount_amount, original_price, deal_price, start_date, end_date, coupon_code, image, storeId, productCategoryId, brandId } = this.state;
    
    console.log("Form submitted with data:", { title, description, start_date, end_date, storeId, productCategoryId, brandId });

    // Prepare the form data
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("startDate", new Date(start_date).toISOString());
    formData.append("endDate", new Date(end_date).toISOString());
    formData.append("couponCode", coupon_code);
    if (image) formData.append("image", image);
    formData.append("store", storeId);
    formData.append("category", productCategoryId);
    formData.append("brands", brandId);

    // Debug the FormData contents
    let formDataObject = {};
    formData.forEach((value, key) => {
        formDataObject[key] = value;
    });
    console.log("FormData contents:", formDataObject);

    try {
        // Make API request
        const response = await axios.post(
            "https://brand.aasmo.in/api/admin/add-deals",
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response && response.status === 201) {
            this.setState({ submissionStatus: 'success' });
            console.log('Deal added successfully');
            setTimeout(() => {
                window.location.href = "/list-deals";
            }, 2000);
        } else {
            console.log('Unexpected response:', response);
        }
    } catch (error) {
        console.error('Error submitting form:', error);
        if (error.response) {
            const { status, data } = error.response;
            if (status === 400) {
                console.error('Bad request error:', data);
            } else if (status === 401) {
                console.error('Unauthorized error, please log in again.');
            } else {
                console.error('Error response:', error.response);
            }
        } else {
            console.error('Network or other error:', error);
        }
    }
};


  render() {
    const { stores, productCategories, brands, submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Add Deals</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChange}
                      placeholder="Title"
                    />
                  </div>
                 
                  <div className="form-group">
                    <label>Coupon Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="coupon_code"
                      value={this.state.coupon_code}
                      onChange={this.handleChange}
                      placeholder="Coupon Code"
                    />
                  </div>
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="start_date"
                      value={this.state.start_date}
                      onChange={this.handleChange}
                      placeholder="Start Date"
                    />
                  </div>
                  <div className="form-group">
                    <label>Product Category</label>
                    <select
                      className="form-control"
                      name="productCategoryId"
                      value={this.state.productCategoryId}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Product Category</option>
                      {productCategories.map(category => (
                        <option key={category._id} value={category._id}>{category.categoryName}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={this.state.description}
                      onChange={this.handleChange}
                      placeholder="Description"
                    />
                  </div>
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="end_date"
                      value={this.state.end_date}
                      onChange={this.handleChange}
                      placeholder="End Date"
                    />
                  </div>
                  <div className="form-group">
                    <label>Store</label>
                    <select
                      className="form-control"
                      name="storeId"
                      value={this.state.storeId}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Store</option>
                      {stores.map(store => (
                        <option key={store._id} value={store._id}>{store.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Brand</label>
                    <select
                      className="form-control"
                      name="brandId"
                      value={this.state.brandId}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Brand</option>
                      {brands.map(brand => (
                        <option key={brand._id} value={brand._id}>{brand.name}</option>
                      ))}
                    </select>
                  </div>
                
                </div>
                  {/* Image input in col-md-12 */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Image</label>
                      <input
                        type="file"
                        className="form-control"
                        name="image"
                        onChange={this.handleFileChange}
                      />
                    </div>
                  </div>
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Deal added successfully!
                </div>
              )}
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});  // Optional: connect Redux store if needed
export default connect(mapStateToProps)(AddDeals);
